//export const baseURL ='http://localhost:3000'

export const baseURL =
    'https://oywqe0nce0.execute-api.eu-west-1.amazonaws.com/latest'

export const quotes = [
    { q: 'It’s like a whole orchestra, the piano for me.', a: 'Dave Brubeck' },
    { q: 'The piano ain’t got no wrong notes.', a: 'Thelonious Monk' },
    {
        q:
            'Sometimes I can only groan, and suffer, and pour out my despair at the piano.',
        a: 'Frederic Chopin',
    },
    {
        q:
            'The typewriting machine, when played with expression, is no more annoying than the piano when played by a sister or near relation.',
        a: 'OSCAR WILDE',
    },
    {
        q:
            'Life is like a piano. What you get out of it depends on how you play it.',
        a: 'Tom Lehrer',
    },
    {
        q:
            'These fingers of mine, they got brains in ’em. You don’t tell them what to do – they do it.',
        a: 'Jerry Lee Lewis',
    },
]
